 /* --------------------------------
 ---- Footer mobile START -------
 ------------------------------- */ 

    $('.footer-block-link_list h2.footer-block__heading').click(function () {
        $(this).parent('.footer-block-link_list').toggleClass('active');
        $(this).parent('.footer-block-link_list').find('ul.footer-block__details-content.list-unstyled').slideToggle();
    })

 /* --------------------------------
 ---- Footer mobile END -------
 ------------------------------- */  
 
 /* --------------------------------
 ---- Featured collection START -------
 ------------------------------- */ 

var swiper = new Swiper(".carousel", {
    pagination: {
    el: ".swiper-pagination",
    },
});


  document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".carousel").forEach(function (el, index) {
    // Init swiper
    const swiper = new Swiper(el, {
      loop: false,
      speed: 400,
      pagination: {
        el: el.querySelector(".swiper-pagination"),
        clickable: true,
      },
    });

    let lastMove = 0;
    let lastDirection = null; // 'left' or 'right'
    const delay = 600; // milliseconds

    el.addEventListener("mousemove", function (e) {
      const now = Date.now();
      if (now - lastMove < delay) return;

      const rect = el.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const width = rect.width;

      const leftZone = width * 0.3;
      const rightZone = width * 0.7;

      if (x < leftZone && lastDirection !== 'left') {
        if (swiper.activeIndex > 0) {
          swiper.slidePrev();
          lastMove = now;
          lastDirection = 'left';
        }
      } else if (x > rightZone && lastDirection !== 'right') {
        if (swiper.activeIndex < swiper.slides.length - 1) {
          swiper.slideNext();
          lastMove = now;
          lastDirection = 'right';
        }
      } else if (x >= leftZone && x <= rightZone) {
        // Reset direction when cursor is in the middle
        lastDirection = null;
      }
    });
  });
});

var totalSlides = document.querySelectorAll('.product_card_image').length;
var swiper = new Swiper('.product_card_inner', {
  loop: totalSlides > 1,
  pagination: totalSlides > 1 ? {
    el: '.card-product-pagi',
    clickable: true,
  } : false,
});

 /* --------------------------------
 ---- Featured collection END -------
 ------------------------------- */  


 /* --------------------------------
 ---- CU FAQ SECTION START -------
 ------------------------------- */  

 $('.cu-faq-section-block-question').click(function(){
    $(this).parent('.cu-faq-section-main-col-block').toggleClass('active');
    $(this).parent('.cu-faq-section-main-col-block').find('.cu-faq-section-block-answer').slideToggle();
 })


 /* --------------------------------
 ---- CU FAQ SECTION END -------
 ------------------------------- */  




 var swiper = new Swiper(".reviewSlider", {
  slidesPerView: "auto",
  spaceBetween: 30,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});



  var swiper = new Swiper(".imagesSlider", {
    slidesPerView: "auto",
    spaceBetween: 30,
    pagination: {
      el: ".images-slider-pagi",
    },
    navigation: {
      nextEl: ".images-slider-next",
      prevEl: ".images-slider-prev",
    },
  });






$('.main-product-par-question-block').click(function(){
  $(this).parent('.main-product-faq-accordion').toggleClass('active');
  $(this).parent('.main-product-faq-accordion').find('.main-product-accordion-answer p').slideToggle();
  $(this).parent('.main-product-faq-accordion').find('.main-product-accordion-answer ol').slideToggle();
  $(this).parent('.main-product-faq-accordion').find('.main-product-accordion-answer ul').slideToggle();
})